export default "/images/d8ddf41ef2bdb8c2e48c0dab3edbfb96.avif";